<template>
  <div class="q-edit-content radio-content q-radio">
    <draggable
      ref="drag"
      @update="moved"
      v-model="value.detail.list"
      :options="{ handle: '.sort-item', animation: 200 }"
      @start="drag = true"
      @end="drag = false"
    >
      <div :class="[!value.ext.edit?'display':'row--edit']" class="row" v-for="(item,index) in value.detail.list">
        <vh-radio
          class="q-select-item"
          :disabled="isPreview||isReplay"
          v-model="val"
          @change="change"
          :label="index"
          :key="index"
        >
          <div class="sort-item" v-if="value.ext.edit">
            <img width="8" src="https://cnstatic01.e.vhall.com/upload/interacts/screen-imgs/202404/4e/00/4e0048314a03b356b433a19a7e41584a9065.png" alt="" style="cursor: move;">
          </div>
          <com-input
            v-if="value.ext.edit"
            placeholder="请输入选项"
            class="chose-item"
            :class="{error:item.error}"
            @focus="itemFocus(item)"
            v-model.trim="item.value"
            :max-length="100">
          </com-input>
          <div
            v-if="!value.ext.edit"
            class="item-text"
            v-text="item.value">
          </div>
        </vh-radio>
        <!-- 其他选项input框 -->
        <com-input v-if="item.custom_opt==1&&(val==index || value.ext.edit)"
                    placeholder="请输入内容"
                    class="otherItem"
                    @focus="itemFocus(item)"
                    v-model.trim="item.otherValue"
                    :disabled="item.disabled"
                    :show-length="!isReplay"
                    :max-length="100"></com-input>
        <span class="remove"
              v-if="value.ext.edit&&value.detail.list.length>2"
              @click.stop="delItem(index)">
           <i class="vh-icon-remove-outline"></i>
        </span>
      </div>
    </draggable>

    <div v-if="!value.ext.edit&&errorTip"
         class="error-msg">{{errorTip}}
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ComInput from '../input/com.vue'
export default {
  name: 'qRadio',
  props: {
    value: {
      type: Object,
      default () {
        return {}
      }
    },
    isPreview:Boolean,
    isReplay:Boolean,
  },

  components: {
    draggable,
    ComInput
  },
  mounted () {
     //回显数据
     if(this.value.replayData){
        let keys = this.value.replayData.split('|')
        const list  = this.value.detail.list
        let index = list.findIndex((e,index)=>{
          return e.key==keys[0]
        })
        this.val = index
        if(keys[1]){
          this.value.detail.list[index].otherValue = keys[1]
        }
        this.value.detail.list[index].disabled = true
      }
  },
  data () {
    return {
      keyVal: '',
      val: '',
      errorTip: '',
      selectVal: '',
      otherValue: '',
      drag:false
    }
  },
  methods: {
    delItem (index) {
      if(this.value.detail.list[index].custom_opt == 1){
        delete this.value.custom_ques
      }
      this.value.detail.list.splice(index, 1)
    },
    change (index) {
      this.value.detail.list.forEach((item, i) => {
        if (i === index) {
          this.selectVal = item.value
          item.is_answer = 1
          this.keyVal =  item.key
        } else {
          item.is_answer = 0
        }
      })
      this.errorTip = ''
    },
    itemFocus (item) {
      if (item.error) {
        item.error = false
        item.value = ''
      }
    },
    check () {
      if (this.value.required==='Y'  && this.val === '') {
        this.errorTip = this.$t('form.form_1083')
        return false
      }
      let flagobj = this.value.detail.list.find(item=>item.value == this.selectVal)
      let obj = { id: this.value.id, value: this.selectVal, style: this.value.style, keyVal: this.keyVal }
      if(flagobj&&flagobj.otherValue&&flagobj.custom_opt == 1){
        obj.keyVal = `${this.keyVal}|${flagobj.otherValue}|`
      }
      return obj
    },
    moved() {

    }
  },
}
</script>

<style scoped lang="scss">
.q-edit-content {
  .row {
    position: relative;
    margin-bottom: 15px;
    &.display {
      margin-bottom: 0px;
    }

    &.row--edit{
      .sort-item{
        cursor: move;
        position: absolute;
        height: 40px;
        //padding-top: 5px;
        //box-sizing: border-box;
        z-index: 2;
        left: 0;
        display: none;
        width: 24px;
        margin-top: -1px;
      }

      .q-select-item {
        &:hover{
          .sort-item{
            display: flex;
            align-items: center;
          }
        }
      }

      ::v-deep {
        .vh-radio__input {
          position: absolute;
          left: 24px;
        }
        .vh-radio__label {
          display: block;
          padding-right: 35px;
          padding-left: 55px;
        }
      }

      .otherItem {
        &.com-input {
          padding-left: 55px;
        }
      }
    }

  }
  ::v-deep {
    .error-msg {
      position: absolute;
      color: #fc5659;
      padding-left: 10px;
      line-height: 20px;
      font-size: 12px;
    }
    .q-select-item {
      width: 100%;
      position: relative;
      &.display {
        margin-bottom: 5px;
      }
    }
    .vh-radio__input {
      margin-top: 12px;
      float: left;
    }
    .vh-radio__label {
      display: block;
      padding-right: 35px;
      padding-left: 24px;
      .com-input {
        margin-right: 8px;
        &.error {
          input {
            border-color: #fc5659;
            color: #fc5659;
          }
          .limit {
            display: none;
          }
        }
      }
    }
    .otherItem{
      margin-top: 15px;
      margin-bottom: 7px;
    }
    .remove {
      position: absolute;
      cursor: pointer;
      font-size: 20px;
      color: #606266;
      top: 8px;
      right: 8px;
      &:hover {
        color: #fc5659;
      }
    }
    .item-text {
      display: inline-block;
      font-size: 12px;
      margin-top: 10px;
      word-wrap: break-word;
      word-break: break-all;
      white-space: normal;
      font-weight: 400;
      line-height: 18px;
    }

    .vh-radio__input.is-disabled .vh-radio__inner, .vh-radio__input.is-disabled.is-checked .vh-radio__inner{
      background-color: #f5f5f5 !important;
      border-color: #d9d9d9 !important;
    }

    .vh-radio__input.is-disabled.is-checked .vh-radio__inner::after {
      background-color: #bfbfbf !important;
    }
  }
}
</style>
